<input
  #thumbnailInput
  type="file"
  data-testid="episode-thumbnail-input-thumbnail-input"
  (change)="onChangeThumbnail(thumbnailInput.files)"
  [accept]="requiredFileType"
  class="d-none"
/>
<div class="episode-thumbnail-input__thumbnail-header">
 <mat-label class="episode-thumbnail-input__thumbnail-title">{{ title }}</mat-label>
  <div class="info-icon-files">
    <mat-icon
      cdkOverlayOrigin
      #overlayOrigin="cdkOverlayOrigin"
      (click)="showOverlay = !showOverlay"
      data-testId="overlay-info-button"
      >info</mat-icon
    >

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="overlayOrigin"
      [cdkConnectedOverlayOpen]="showOverlay"
      [cdkConnectedOverlayHasBackdrop]="showOverlay"
      [cdkConnectedOverlayBackdropClass]="
        'cdk-overlay-transparent-backdrop-cs'
      "
      (backdropClick)="showOverlay = !showOverlay"
    >
      <ng-container *ngTemplateOutlet="overlayContent"></ng-container>
    </ng-template>
  </div>
</div>
 
<div
  #episodeThumbnailContainer
  class="episode-thumbnail-input__thumbnail"
  [ngClass]="{
    'episode-thumbnail-input__thumbnail--dragging-over':
      isDraggingOverThumbnailElement
  }"
  (dragend)="onThumbnailDragEnd($event)"
  (dragleave)="onThumbnailDragLeave($event)"
  (dragover)="onThumbnailDragOver($event)"
  (drop)="onThumbnailDrop($event)"
>
  <!-- Element that is going to be displayed while the user is dragging the image over the episode thumbnail -->
  <ng-template #draggingOverThumbnailOverlay>
    <div class="episode-thumbnail-input__thumbnail-dragging-over-overlay">
      <mat-icon>add</mat-icon>
      <span>Drop to upload</span>
    </div>
  </ng-template>
  <!-- Default contents of the thumbnail -->
  <ng-template #episodeThumbnailPlaceholder>
    <ng-container
      *ngIf="!isDraggingOverThumbnailElement; else draggingOverThumbnailOverlay"
    >
      <mat-icon class="episode-thumbnail-input__thumbnail-placeholder-image material-symbols-outlined">cloud_upload</mat-icon>
      <div class="episode-thumbnail-input__thumbnail-placeholder">
        <span>Drag & Drop Here</span>
      </div>
      <div class="episode-thumbnail-input__thumbnail-button">
        <button class="mr-3 " mat-button (click)="thumbnailInput.click()">
          Attach
        </button>
      </div>
    </ng-container>
  </ng-template>
  <!-- Show a spinner while we are processing and validating the image -->
  <ng-template #processingThumbnailOverlay>
    <div
      *ngIf="isProcessingThumbnail; else episodeThumbnailPlaceholder"
      class="episode-thumbnail-input__thumbnail-processing-overlay d-flex flex-column align-items-center"
    >
      <mat-spinner class="mb-3" [diameter]="40"></mat-spinner>
      <div>Processing</div>
    </div>
  </ng-template>
  <img
    *ngIf="thumbnail !== null; else processingThumbnailOverlay"
    [src]="thumbnail.previewUrl"
    [ngStyle]="{
      width: thumbnail.width + 'px',
      height: thumbnail.height + 'px'
    }"
    alt="Thumbnail"
    class="episode-thumbnail-input__thumbnail-image"
  />
  <div
    class="episode-thumbnail-input__thumbnail-actions"
    *ngIf="thumbnail !== null"
  >
    <button mat-icon-button (click)="thumbnailInput.click()">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button (click)="onChangeThumbnail(null)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>

<ng-template #overlayContent>
  <div class="overlay-info-format" data-testId="compatible-format-info">
    <div class="overlay-info-container">
      <div class="overlay-title">
        <div class="title">Compatible Image Formats</div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="info-icon">           
            <mat-icon class="material-symbols-outlined">
              imagesmode
            </mat-icon>            
            <div class="info-icon--icon-label">IMAGE</div>
          </div>
        </div>
        <div class="col mb-2">
          <div class="overlay-info">
            <div class="overlay-info-header">
              <div class="info-image">           
                <img
                  src="../../../../../../assets/images/icon-format-img-horz.png"
                  alt="vertical image"
                />
              </div>
              <div class="info">
                <div class="title">Horizontal Image</div>
                <ul>
                  <li>700px h x 200px w</li>
                  <li>300dpi ir grater</li>
                  <li>JPEG or PNG</li>
                </ul>
              </div>
            </div>
            <div class="overlay-info-footer" *ngIf="tootipPlacementImageUrl">
              <div class="info">
                <div class="title">Placement on Show Guide</div>
              </div>
              <div class="info-image">           
                <img
                  [src]="'../../../../../../assets/images/'+tootipPlacementImageUrl"
                  alt="vertical image"
                />
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
    </div>
  </div>
</ng-template>